import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class BaseService {
	mapInterval: any;

  mapLoadedChangeSource = new BehaviorSubject<boolean>(false);
  mapLoadedChangeStream = this.mapLoadedChangeSource.asObservable();

  paramChangeSource = new BehaviorSubject<boolean>(false);
  paramChangeStream = this.paramChangeSource.asObservable();
  
  constructor() { }

  isEmbedLoaded() {
  }

	checkIfMapLoaded() {
    let w = (<any>window);
    if(w.mmap && w.mmap.googleMapFullyLoaded) {
      this.mapLoadedChangeSource.next(true);
    } else {
      w.Events.subscribe('googleMapFullyLoaded', ()=>{
        this.mapLoadedChangeSource.next(true);
      });
    }
	}

	constructGeoJsonPolygon(NEBounds, SWBounds) {
		return {
	    			type: 'Polygon',
				    srid:null,
				    coordinates: [[
				      [NEBounds.toJSON().lng, NEBounds.toJSON().lat],
				      [SWBounds.toJSON().lng, NEBounds.toJSON().lat],
				      [SWBounds.toJSON().lng, SWBounds.toJSON().lat],
				      [NEBounds.toJSON().lng, SWBounds.toJSON().lat],
				      [NEBounds.toJSON().lng, NEBounds.toJSON().lat]
				    ]]
				  }
	}
	
	stopProp(e) {
	  e.stopPropagation();
	}

  focusFirstEmptyElement(elementClass) {
    let inputVal : any = <HTMLElement><any> document.getElementsByClassName(elementClass);
    if(inputVal) {
      for (let i = 0; i < inputVal.length; i++) {
        if(!inputVal[i].value || inputVal.length === 1) {
          inputVal[i].focus();
          return false;
        }
      }
    }
  }

  addIpadClass() {
    let w = (<any>window),
        isIpad = /ipad/i.test(w.navigator.userAgent);
    if(isIpad) {
      w.addClass(document.getElementsByTagName('body')[0], 'ipad-mode');
    }
  }

  addBrowserAndDeviceSettings() {
    this.addIpadClass();
    this.addWindowResizeListener();
  }

  addWindowResizeListener() {
    let w = (<any>window),
        domBody = document.getElementsByTagName('body')[0];

    w.addEventListener('resize', w.debounce((event)=> {
      w.mmap.windowResizeEvent();
      
      if((w.hasClass(domBody, 'user-map') || w.hasClass(domBody, 'received-map')) && window.innerWidth <= 1023) {
        w.resizeMapNameIfLong();
      }
    }, 500));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/base.service.ts